import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import FadeIn from "react-fade-in";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans } from "react-i18next";
import Button from "@material-ui/core/Button";
import ActionButton from "../ActionButton";
import SendIcon from "@material-ui/icons/Send";
import { CardHeader } from "@material-ui/core";
import ReactDOM from "react-dom";

const styles = (theme) => ({
  hidden: {
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 9999999999,
    visibility: "hidden",
    display: "none",
  },
  card: {
    overflow: "hidden",
  },
  show: {
    position: "fixed",
    top: 100,
    left: "25px",
    // zIndex: 99999999,
    zIndex: 1301,
    visibility: "visible",
    display: "block",
  },
});
export class KpsDialog extends Component {
  static propTypes = {
    documentId: PropTypes.number.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      width: 450,
      height: 650,
    };
  }
  onResize = (event, { element, size, handle }) => {
    if (this.props.resize) {
      this.props.resize(size.width, size.height);
    }
    this.setState({ width: size.width, height: size.height });
  };
  onStart = () => {
    this.setState({ activeDrags: ++this.state.activeDrags });
  };

  onStop = () => {
    this.setState({ activeDrags: --this.state.activeDrags });
  };

  render() {
    const { classes, t } = this.props;
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    return ReactDOM.createPortal(
      <Draggable
        handle=".handle"
        {...dragHandlers}
        className={this.props.open ? classes.show : classes.hidden}
      >
        <Card
          role="dialog"
          aria-labelledby="dialog-title"
          raised
          aria-hidden={!this.props.open}
          id="card"
          className={this.props.open ? classes.show : classes.hidden}
          style={{ top: this.props.top }}
        >
          <ResizableBox
            height={this.state.height}
            width={this.state.width}
            onResize={this.onResize}
            resizeHandles={["se"]}
          >
            <CardHeader
              className="handle"
              style={{ cursor: "move" }}
              titleTypographyProps={{ component: "h3", id: "dialog-title" }}
              title={this.props.title}
            />
            <DialogContent
              style={{
                height: "100%",
                maxHeight: this.state.height - 160,
              }}
            >
              {this.props.children}
            </DialogContent>
            <DialogActions>
              <div style={{ display: "flex" }} />
              <Button
                variant="contained"
                onClick={this.props.close}
                className={classes.button}
                autoFocus
              >
                <Trans i18nKey="global_cancel" />
              </Button>
              <ActionButton
                id="kps-dialog-save-button"
                variant="contained"
                loading={this.props.loading}
                className={classes.button}
                onClick={this.props.accept}
                aria-label="Save"
              >
                <SendIcon />
              </ActionButton>
            </DialogActions>
          </ResizableBox>
        </Card>
      </Draggable>,
      document.body
    );
  }
}
export default withStyles(styles)(KpsDialog);
